const contact = {
  header: {
    overline: "LET'S CONNECT",
    titlePrefix: "Let's Build the",
    titleHighlight: "Next Big Thing",
    titleSuffix: "Together",
    subtitle:
      "Have a complex data challenge or a visionary AI project? I'm here to provide the technical expertise and strategic guidance to make it a reality.",
  },
  benefits: ["Response within 24 hours", "Direct expert consultation", "Scalable architecture focus", "Production-ready AI solutions"],
  form: {
    title: "Quick Message",
    fullName: "Full Name",
    email: "Email Address",
    phone: "Phone Number",
    subject: "Subject",
    details: "Project Details",
    submit: {
      idle: "Send Proposal",
      loading: "Sending...",
    },
  },
  info: {
    linkedin: { label: "LinkedIn", value: "Alexandre SANOU" },
    location: { label: "Location", value: "Ile-De-France / Remote" },
  },
  footer: {
    titlePrefix: "Transforming Challenges into",
    titleHighlight: "Competitive Advantages",
    subtitle:
      "I don't just write code; I design intelligent systems that drive business growth. Let's discuss how my expertise in Data Science and Full-Stack development can elevate your next project.",
  },
  modal: {
    successTitle: "Success!",
    errorTitle: "Error",
    close: "Close",
    successMessage:
      "🚀 Strategy session requested! Happy to assist you, {{name}}. I will get back to you within 24 hours.",
    errorMessage: "An error occurred. Please try again later.",
  },
};

export default contact;
